/**
 * Stable, random identifier for this device (browser profile), used as the
 * HLC node id. It identifies a *replica*, not a person: it is never sent
 * anywhere except inside the replicated timestamps themselves.
 */
import { HybridClock } from './hlc.ts'

const DEVICE_ID_KEY = 'quipwa:device-id'

function randomId(): string {
  const bytes = new Uint8Array(6)
  crypto.getRandomValues(bytes)
  return Array.from(bytes, (b) => b.toString(16).padStart(2, '0')).join('')
}

export function getDeviceId(storage: Pick<Storage, 'getItem' | 'setItem'> = localStorage): string {
  let id = storage.getItem(DEVICE_ID_KEY)
  if (!id || !/^[A-Za-z0-9_]+$/.test(id)) {
    id = randomId()
    storage.setItem(DEVICE_ID_KEY, id)
  }
  return id
}

let shared: HybridClock | null = null

/** The process-wide clock for this device. */
export function getDeviceClock(): HybridClock {
  shared ??= new HybridClock(getDeviceId())
  return shared
}

/** Tests only: forget the shared clock. */
export function resetDeviceClock(): void {
  shared = null
}
